import React from 'react';
import { FiActivity, FiBarChart2, FiImage, FiMessageCircle, FiUser } from 'react-icons/fi';
import type { ChannelSyncStateResponse } from '@troia-v3/types';

import { relativeSince } from './formatMetrics';

type ResourceKey = 'profile' | 'metrics' | 'media' | 'comments' | 'activities';
const RES: Array<{ key: ResourceKey; label: string; icon: React.ReactNode }> = [
  { key: 'profile', label: 'Perfil', icon: <FiUser size={16} /> },
  { key: 'metrics', label: 'Métricas', icon: <FiBarChart2 size={16} /> },
  { key: 'media', label: 'Publicações', icon: <FiImage size={16} /> },
  { key: 'comments', label: 'Comentários', icon: <FiMessageCircle size={16} /> },
  { key: 'activities', label: 'Atividade', icon: <FiActivity size={16} /> },
];

export const SyncSection: React.FC<{ syncState: ChannelSyncStateResponse | null }> = ({ syncState }) => (
  <div data-testid="cdash-sync-section">
    <span className="cdash-mlabel">Estado de sincronização</span>
    <div className="cdash-sync-grid">
      {RES.map((r) => {
        const st = syncState?.resources?.[r.key];
        const hasError = !!st?.lastError;
        const synced = !!st?.lastSyncedAt;
        return (
          <div className="cdash-sync-row" key={r.key} data-testid={`cdash-sync-${r.key}`}>
            <span className="cdash-sync-ic">{r.icon}</span>
            <div>
              <div className="cdash-sync-t1">{r.label}</div>
              <div className="cdash-sync-t2">
                {hasError ? st?.lastError : synced ? `Sincronizado ${relativeSince(st?.lastSyncedAt)}` : 'Ainda não sincronizado'}
              </div>
            </div>
            <span className={`cdash-sync-badge ${hasError ? 'err' : synced ? 'ok' : 'idle'}`}>
              {hasError ? 'Erro' : synced ? 'OK' : '—'}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
